import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearActiveReplyMessage } from '../../actions/chatWindow/actions';
import { ReplyPreview } from '../../components/ReplyPreview';
import { currentOpenChatIDSelector, currentOpenChatSelector, selectActiveReplyMessage } from '../../selectors';
import { useRepliesEnabled } from '../../hooks/useRepliesEnabled';
import { useApplicationContext } from '../../utils/applicationContext';
import { useReplyScrollStoreContext } from '../../utils/replyScrollContext';
import { getReplyAuthorName } from '../../utils/getReplyAuthorName';
import { getReplyMessageContent } from './utils';

export const ReplyPreviewContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isRepliesEnabled = useRepliesEnabled();
  const { scrollToReplyTargetMessage } = useReplyScrollStoreContext();

  const chatId = useSelector(currentOpenChatIDSelector) || '';
  const { users = [] } = useSelector(currentOpenChatSelector) || {};
  const activeReplyMessage = useSelector(selectActiveReplyMessage);

  const {
    custom: { messagesMap },
  } = useApplicationContext();

  const replyProps = React.useMemo(() => {
    if (!chatId || !activeReplyMessage) {
      return null;
    }

    const message = messagesMap.get(activeReplyMessage.messageId)?.message?.message;

    if (!message || message.isDeleted) {
      return null;
    }

    const authorName = getReplyAuthorName({ users, userId: message.userId });
    const { text, thumbnail } = getReplyMessageContent({ message, chatId });

    return {
      authorName,
      text,
      thumbnail,
      onQuoteClick: () => scrollToReplyTargetMessage(activeReplyMessage.messageId),
    };
  }, [chatId, users, messagesMap, scrollToReplyTargetMessage, activeReplyMessage]);

  const handleClose = React.useCallback(() => {
    dispatch(clearActiveReplyMessage());
  }, [dispatch]);

  if (!isRepliesEnabled || !replyProps) {
    return null;
  }

  return <ReplyPreview {...replyProps} onClose={handleClose} />;
};
